import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Stack, Typography } from "@mui/material";
import { useParams } from "react-router-dom";

import { useGetCustomerQuotes } from "../../hooks/react-query/useSalesData";
import { HubTableTemplate } from "../../components";
import { useGetCustomerDetailsById } from "../../hooks";
import { EmptyGeneral } from "../../svgs";

import { items, keys } from "./helper";

export const CustomerQuotes = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: quotes, isLoading } = useGetCustomerQuotes(id);
  const { data: customer } = useGetCustomerDetailsById(id);

  const isVendor = !!customer?.isVendor;
  const rows = (quotes || []).map((q) => ({
    ...q,
    isVendorQuote: false,
  }));

  const onRowClick = (e, item) => {
    if (item?.quoteNumber) navigate(`/quotes/${item.quoteNumber}`);
  };

  if (!isLoading && !rows.length) {
    return (
      <Stack gap="25px" margin="auto" alignItems="center" py="40px">
        <Box component="img" src={EmptyGeneral} sx={{ height: "120px" }} />
        <Stack gap="6px" alignItems="center" textAlign="center">
          <Typography variant="boldCaption">No Quotes Found</Typography>
          <Typography variant="caption" width="250px">
            {isVendor
              ? "No vendor quotes or casting quotes exist for this customer yet."
              : "No casting quotes have been created for this customer yet."}
          </Typography>
        </Stack>
      </Stack>
    );
  }

  return (
    <HubTableTemplate
      id="CustomerQuotesTable"
      headerProps={{ items, includeEnd: false }}
      bodyProps={{ items: rows, keys, onRowClick }}
      isLoading={isLoading}
    />
  );
};

export default CustomerQuotes;
